import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./SearchResults.css";
import AllProperties from "../AllProperties/AllProperties";
// Importamos a função da API aqui, pois é este componente que vai buscar os dados
import { listAllApprovedProperties } from "../../../services/api/properties"; 

export default function SearchResults() {
  const location = useLocation();
  // Pegamos apenas o termo de busca vindo da HorizontalBar
  const { searchTerm } = location.state || { searchTerm: "" };
  
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Estados de Paginação controlados por AQUI
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  // Efeito para resetar a página se o termo mudar
  useEffect(() => {
    setPage(1);
  }, [searchTerm]);

  // Efeito que faz a busca na API
  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        // Chamamos a API pedindo a página 'page' e passando o filtro 'search'
        const data = await listAllApprovedProperties(page, 30, { search: searchTerm });
        
        setProperties(data.properties || []);
        setTotalItems(data.total || 0);
      } catch (error) {
        console.error("Erro na busca:", error);
        setProperties([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    }

    if (searchTerm) {
      fetchData();
    } else {
        setLoading(false);
    }
  }, [searchTerm, page]); // Roda quando muda o termo ou a página

  const renderTitle = () => {
    if (loading) return <span>Buscando imóveis...</span>;
    if (totalItems === 0) return <>Nenhum imóvel encontrado para: <span>"{searchTerm}"</span></>;

    return (
      <>
        Encontramos <strong>{totalItems}</strong> {totalItems === 1 ? 'imóvel disponível' : 'imóveis disponíveis'} para: <span>"{searchTerm}"</span>
      </>
    );
  };

  return (
    <main className="search-results-page">
      <header className="search-header">
        <h1 className="search-results-title">{renderTitle()}</h1>
      </header>

      {loading ? (
        <div className="loading-container">
          {[1, 2, 3].map((n) => (
            <div key={n} className="skeleton-card">
              <div className="skeleton-image"></div>
              <div className="skeleton-text short"></div>
              <div className="skeleton-text long"></div>
              <div className="skeleton-text medium"></div>
            </div>
          ))}
        </div>
      ) : (
        <AllProperties
          especific_database={properties} 
          filters_visible={false} 
          title_visible={false}
          undefined_mensage={`Nenhum imóvel encontrado para "${searchTerm}"`}
          storageContext="searchResults"
          
          // Novas props para controle externo
          forcedTotal={totalItems} 
          externalPageControl={{
            currentPage: page,
            setPage: setPage
          }}
        />
      )}
    </main>
  );
}